import { apiFetch } from "../../../lib/apiClient";
import CERTIFICATE_COURSE_ROUTES from "./certificateCourseRoutes.json";

/**
 * courseId for the course hub at `pathname` (e.g. "/learn/ai_ml-py" or one of
 * its lesson pages), or null. The map is generated by
 * scripts/generate-certificate-courses.mjs.
 */
export function certificateCourseIdForPath(pathname = "") {
  const match = String(pathname).match(/^\/learn\/[^/]+/);
  return (match && CERTIFICATE_COURSE_ROUTES[match[0]]) || null;
}

/** Return the signed-in learner's certificate, issuing it if the server confirms the course is complete. */
export async function issueCertificate(courseId, token) {
  const data = await apiFetch("/certificates", {
    method: "POST",
    token,
    body: JSON.stringify({ courseId }),
    fallbackMessage: "Could not load your certificate",
  });
  return data.certificate;
}

/** Public lookup by certificate id; throws ApiError (status 404) if unknown. */
export async function getCertificate(certificateId) {
  const data = await apiFetch(
    `/certificates/${encodeURIComponent(certificateId)}`,
    { auth: false, fallbackMessage: "Could not load the certificate" },
  );
  return data.certificate;
}

/** Certificates the server has issued to `username`, newest first. */
export async function listUserCertificates(username) {
  const data = await apiFetch(
    `/certificates/user/${encodeURIComponent(username)}`,
    { auth: false, fallbackMessage: "Could not load certificates" },
  );
  return data.certificates || [];
}
